// Pinterest's post types, media types, sort keys, metrics, scales and pin privacy, as the API
// spells them. Sorts carry their leading `-` because that is what the query string wants.
export const enumTypes = {
  // types
  ALL: 'ALL',
  UGC: 'UGC',
  OWN: 'OWN',
  // media
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  // sorts
  PUBLISHED_DATE: '-PUBLISHED_DATE',
  TOTAL_VISITS: '-TOTAL_VISITS',
  TOTAL_SAVES: '-TOTAL_SAVES',
  TOTAL_CLICKS: '-TOTAL_CLICKS',
  TOTAL_CLOSEUPS: '-TOTAL_CLOSEUPS',
  TOTAL_IMPRESSIONS: '-TOTAL_IMPRESSIONS',
  TOTAL_ENGAGEMENT: '-TOTAL_ENGAGEMENT',
  TOTAL_COMMENTS: '-TOTAL_COMMENTS',
  TOTAL_TRAFFIC: '-PINTEREST_TRAFFIC',
  TOTAL_VIDEO_VIEWS: '-TOTAL_VIDEO_VIEWS',
  AVERAGE_VIDEO_WATCH_TIME: '-AVERAGE_VIDEO_WATCH_TIME',
  MOST_RECENT: '-CREATED',
  // metrics
  VISITS: 'VISITS',
  TRAFFIC: 'TRAFFIC',
  CLICKS: 'CLICKS',
  LINK_CLICKS: 'LINK_CLICKS',
  SAVES: 'SAVES',
  IMPRESSIONS: 'IMPRESSIONS',
  ENGAGEMENTS: 'ENGAGEMENTS',
  ENGAGEMENT_RATE: 'ENGAGEMENT_RATE',
  ENGAGEMENT: 'ENGAGEMENT',
  CLOSEUPS: 'CLOSEUPS',
  COMMENTS: 'COMMENTS',
  VIDEO_VIEWS: 'VIDEO_VIEWS',
  // scales
  HOURLY: 'HOURLY',
  DAILY: 'DAILY',
  MONTHLY: 'MONTHLY',
  // Pin Privacy
  PUBLIC: 'PUBLIC',
  PROTECTED: 'PROTECTED',
};
